import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";

export class RemoveKundorderradAlternativaHandelssortimentCommand extends BasicCommand<RemoveKundorderradAlternativaHandelssortimentCommand> {
    primaryKey: import("../../../../../../common/services/cqs/IPrimaryKey").IPrimaryKey<RemoveKundorderradAlternativaHandelssortimentCommand>;
    kundorderradId: number;
    handelssortiment: number[];
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "KundorderAlteranativthandelssortiment";

    constructor(kundorderradId: number) {
        super("RemoveKundorderradAlternativaHandelssortimentCommand", "kundorderrad", CommandType.Replace);
        this.kundorderradId = kundorderradId;
    }
}
